<div class="container-div d-flex justify-content-between flex-column">
  <div class="heading-content d-flex justify-content-between">
    <div class="primary-div">
    <div class="header-content">
      <span class="heading-text">
        Dikshyarthi’s details -
        {{ data.data.memberKey}}
      </span>
      <span class="heading-text-2">
        {{data?.updatedBy? 'Added By - '+ data.updatedBy: data.data.updatedByFWName? 'Updated By -' +
        data.data.updatedByFWName:''}}
      </span>
     
    </div>
     @if(data.data.isPrimary){
        <span class="primary-mem">Primary</span>
      }
      </div>
    <div class="img-div" mat-dialog-close>
      <img alt="cross" class="img-cross" src="../../../assets/images/cross_white.svg" />
    </div>
  </div>
  @if(data.data.memberKey){
    @if(data.data.memKeysMergeRecords.length >0){
    @if(data.data.isPrimary){
    <div class="content-div">
       <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Serial no. merged with</span>
      </div>
      <div class="merge-details d-flex">
        @for(item of data.data.memKeysMergeRecords; track item){
        <span class="serial-no" (click)="copy(item)" title="Click to copy" style="max-width: 100% !important;">{{ item }}</span>
        }
      </div>
    </div>
    </div>
  }@else {
    <div class="content-div">
       <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Primary serial no.</span>
      </div>
      <div class="merge-details d-flex">
        @for(item of data.data.memKeysMergeRecords; track item){
        <span class="serial-no" (click)="copy(item)" title="Click to copy" style="max-width: 100% !important;">{{ item }}</span>
        }
      </div>
    </div>
    </div>
  }
}

  <div class="content-div">
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Personal Details</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Name</span>
          <span class="details-data">{{ data.data.fullName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Suggested Name</span>
          <span class="details-data">{{ data.data.suggestedMemberName || '-' }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Guardian's Name</span>
          <span class="details-data">{{ data.data.guardianName }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Ritwick's Name</span>
          <span class="details-data">{{ data.data.ritwikName }}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Initiation Information</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Member Status</span>
          <span class="details-data">{{ data.data.status }}</span>
        </div>
        @if(data.data.memStatus===2 || data.data.memStatus===3){
        <div class="details d-flex justify-content-between">
          <span class="details-head">Updated as</span>
          <span class="details-data">{{ data.data.memStatus===2?'Active':'Inactive' }}</span>
        </div>}
        <div class="details d-flex justify-content-between">
          <span class="details-head">Family Code</span>
          <span class="details-data">{{ data.data.memberFamilyCode }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Contact Number</span>
          <span [class]="showContact?'details-data-click':'details-data'" (click)="onContactClick(data.data)">{{
            data.data.contactNumber || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Email Address</span>
          <span class="details-data">{{ data.data.email || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <div class="content-div">
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Permanent Address</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head">Address</span>
          <span class="details-data">{{
            data.data.permanentAddressLine1 || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Landmark</span>
          <span class="details-data">{{
            data.data.permanentLandmark || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Pincode</span>
          <span class="details-data">{{ data.data.permanentPin || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">PostOffice</span>
          <span class="details-data">{{ data.data.permanentPO || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">District</span>
          <span class="details-data">{{
            data.data.permanentDistrict || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">state</span>
          <span class="details-data">{{
            data.data.permanentState || "-"
            }}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Present Address</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head"> Address</span>
          <span class="details-data">{{
            data.data.presentAddressLine1 || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Landmark</span>
          <span class="details-data">{{
            data.data.presentLandmark || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">Pincode</span>
          <span class="details-data">{{ data.data.presentPin || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">PostOffice</span>
          <span class="details-data">{{ data.data.presentPO || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">District</span>
          <span class="details-data">{{
            data.data.presentDistrict || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">state</span>
          <span class="details-data">{{ data.data.presentState || "-" }}</span>
        </div>
      </div>
    </div>
    
  </div>
  <div class="content-div">
     <div class="first-div d-flex flex-column">
      <!-- <div class="personal-info"> -->
      <div class="heading">
        <span class="grid-head">Old Address</span>
        <!-- </div> -->
      </div>
      <div class="info-details d-flex">
        <div class="details d-flex justify-content-between">
          <span class="details-head"> Address</span>
          <span class="details-data">{{
            data.data.addressPermanent || "-"
            }}</span>
        </div>
        <!-- <div class="details d-flex justify-content-between">
          <span class="details-head">Landmark</span>
          <span class="details-data">{{
            data.data.presentLandmark || "-"
            }}</span>
        </div> -->
        <div class="details d-flex justify-content-between">
          <span class="details-head">Pincode</span>
          <span class="details-data">{{ data.data.permanentPin || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">PostOffice</span>
          <span class="details-data">{{ data.data.permanentPO || "-" }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">District</span>
          <span class="details-data">{{
            data.data.permanentDistrict || "-"
            }}</span>
        </div>
        <div class="details d-flex justify-content-between">
          <span class="details-head">state</span>
          <span class="details-data">{{ data.data.permanentState || "-" }}</span>
        </div>
      </div>
    </div>
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Summary (Comments)</span>
      </div>
      <div class="info-details d-flex">
        <span class="details-head" style="max-width: 100% !important;">{{ data.data.comments || "-" }}</span>
      </div>
      
    </div>
    @if(data.data.recordStatus===6|| data.data.recordStatus===8){
    <div class="first-div d-flex flex-column">
      <div class="heading">
        <span class="grid-head">Rejection Reason</span>
      </div>
      <div class="info-details d-flex">
        <span class="details-head" style="max-width: 100% !important;">{{ data.data.rejectedReasonByDA || "-" }}</span>
      </div>
    </div>
    }
  </div>
  }
</div>
<!-- <app-loader [isLoading]="isLoading"></app-loader> -->